var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowFull = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  d: "M20.97 6.64 7.01 21.31a3.94 3.94 0 0 0 0 5.37l14 14.76c.76.78 1.99.81 2.77.08a1.94 1.94 0 0 0 .06-2.76L11.72 25.99h28.36a1.95 1.95 0 1 0 0-3.9H11.66L23.79 9.34c.74-.78.72-2-.07-2.76a1.96 1.96 0 0 0-2.76.08z"
})));
export { SvgArrowFull as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/arrow-full.svg", import.meta.url).toString();